import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import CountryCMSModel from '@/visa-application/models/CountryCMSModel';

export default class TravelPurposeCMSModel implements CMSModel {
  bannerTitle = '';
  bannerSubTitle = '';
  cardTitle = '';
  actionTitle = '';
  actionButton = '';
  actionLink = '';
  actionDesc = '';
  meta_title = '';
  meta_description = '';
  meta_keywords = '';
  country: CountryCMSModel = new CountryCMSModel();
  hide_register_button: boolean;

  map(obj: any): void {
    this.bannerTitle = _.get(obj, 'translation[0].banner_title', 'Undefined');
    this.bannerSubTitle = _.get(obj, 'translation[0].banner_sub_title', 'Undefined');
    this.cardTitle = _.get(obj, 'translation[0].card_title', 'Undefined');
    this.actionTitle = _.get(obj, 'translation[0].action_title', 'Undefined');
    this.actionButton = _.get(obj, 'translation[0].action_button', 'Undefined');
    this.actionLink = _.get(obj, 'translation[0].action_link', 'Undefined');
    this.actionDesc = _.get(obj, 'translation[0].action_desc', 'Undefined');
    this.meta_title = _.get(obj, 'translation[0].meta_title', '');
    this.meta_description = _.get(obj, 'translation[0].meta_description', '');
    this.meta_keywords = _.get(obj, 'translation[0].meta_keywords', '');
    this.country = _.get(obj, 'country', {});
    this.hide_register_button = _.get(obj, 'hide_register_button', false);
  }
}
